import './style.scss'

import React from 'react'

const ProgressBar = ({ percent }) => {
  return (
    <div className='progress-bar'>
      <div className='-overlay-container' style={{ width: percent + '%' }}>
        <div className='-overlay'>
          <div className='-percent'>{percent}%</div>
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
